import { shallowRef } from 'vue'
import {
  documentAgreementImportRoutes,
  documentAgreementRoutes,
} from '@/requests/documentAgreement'
import { templateRouteList } from '@/requests/templateRoute'
import { DocumentAgreementRoute } from '@/utils/types/documentAgreement'
import { handleAsync } from 'best-modules/plugins'
import { openDialog } from '@/dialog'
import { DocumentAgreementContext } from '../types'
import { useCan } from '@/composables/useCan'

export function useRoutes(context: DocumentAgreementContext) {
  const { documentAgreementId, documentAgreementSource } = context
  const { can } = useCan()
  const routes = shallowRef<DocumentAgreementRoute[]>([])

  const getRoutes = () => {
    return handleAsync('getRoutes', async () => {
      if (
        documentAgreementSource.templateId &&
        can('document-templates.viewAny')
      ) {
        const data = await templateRouteList(
          'default',
          documentAgreementSource.templateId
        )

        routes.value = 'routes' in data ? data.routes : data
      } else {
        const data = await documentAgreementRoutes(documentAgreementId.value)

        routes.value = data
      }
    })
  }

  const updateTemplateRoutes = () => {
    openDialog({
      name: 'TemplateGroup',
      action: 'update',
      dialogData: { document: documentAgreementSource },
      params: {
        cb: (res: DocumentAgreementRoute[]) => {
          routes.value = res
        },
      },
    })
  }

  const updateTemplate = () => {
    openDialog({
      name: 'TemplateSelect',
      dialogData: { document: documentAgreementSource },
      params: {
        cb: templateId => {
          documentAgreementImportRoutes(documentAgreementId.value, {
            templateId,
          }).then(res => {
            routes.value = res
          })
        },
      },
    })
  }

  return { routes, getRoutes, updateTemplate, updateTemplateRoutes }
}
